import FixaSSRIcon from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import CircleFilledIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/CircleFilledIconPath";
import { ComponentNotificationTitleSeriesClose } from "@fixa/notifications";
import { getTitleAssignerString } from "../utils/task-notification-title";
import styles from "../task-notification.module.css";
import { useTranslation } from "@coworker/locales";

interface TaskNotificationTitleCreatorSeriesClosedProps extends ComponentNotificationTitleSeriesClose {
  read: boolean;
}

const TaskNotificationTitleCreatorSeriesClosed = ({
  props: { closedBy },
  read,
}: TaskNotificationTitleCreatorSeriesClosedProps) => {
  const { t } = useTranslation();
  const closedByString = getTitleAssignerString(closedBy);
  return (
    <div className={styles["task-notification-item-title"] ?? ""}>
      {!read && <FixaSSRIcon paths={CircleFilledIconPath} />}
      {t("taskSeriesClosedByString", { closedBy: closedByString })}
    </div>
  );
};

export default TaskNotificationTitleCreatorSeriesClosed;
